<template>
    <div class="attach-customer">
        <dl class="attach-customer-body dl-horizontal">
            <dt>{{labelText}}:</dt>
            <dd v-if="!isDataLoaded">
                <div class="loading loading-left loading-sm"></div>
            </dd>
            <template v-for="relation in relations" v-if="isDataLoaded">
                <dd>
                    <a v-if="customerLink(relation.id)" v-bind:href="customerLink(relation.id)">{{relation[getAnchor()]}}</a>
                    <template v-if="!customerLink(relation.id)">{{relation[getAnchor()]}}</template>
                    <span class="clickable glyphicon glyphicon-trash" v-on:click="removeRelation(relation.id)"></span>
                </dd>
            </template>
            <template v-if="isDataLoaded">
                <dd v-show="!showAddForm" v-on:click="addModeOn()"><a href="#">Add New</a> <span class="clickable glyphicon glyphicon-plus" v-on:click="removeRelation(relation.id)"></span></dd>
                <dd v-show="showAddForm"><autocomplete ref="autocomplete" :debounce="debounce" :placeholder="getPlaceholder()" url="#" :onSelect="addRelation" :onShouldGetData="getOptions" :anchor="getAnchor()" label="id"></autocomplete></dd>
            </template>
        </dl>
    </div>
</template>

<script>
    import axios from 'axios'
    import querystring from 'querystring'
    import Autocomplete from 'vue2-autocomplete-js'

    export default {
        components: { Autocomplete },
        props: ['relationapi', 'addapi', 'removeapi', 'searchapi', 'customerLinkURL', 'id', 'label', 'anchorField', 'searchPlaceholder'],
        name: 'attachCustomer',
        data () {
            return {
                debounce: 250,
                relations: null,
                addMode: false
            }
        },
        computed: {
            showAddForm: function () {
                return this.addMode
            },
            isDataLoaded: function () {
                return this.relations !== null
            },
            labelText: function () {
                return this.label || 'Related'
            }
        },
        methods: {
            addModeOn: function () {
                this.addMode = true
            },
            addModeOff: function () {
                this.addMode = false
            },
            getAnchor: function () {
                return this.anchorField || 'businessName'
            },
            getPlaceholder: function () {
                return this.searchPlaceholder || 'Search Accounts'
            },
            getData: function () {
                let self = this
                return axios.post(this.relationapi, querystring.stringify({id: this.id}), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
                    .then(function (response) {
                        self.relations = response.data.relations
                    })
            },
            getOptions (value) {
                return new Promise((resolve, reject) => {
                    axios.post(this.searchapi, querystring.stringify({search: value}), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
                        .then(function (response) {
                            resolve(response.data.results)
                        })
                })
            },
            addRelation (data) {
                let self = this

                return axios.post(this.addapi, querystring.stringify({id: self.id, relation: data.id}), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
                    .then(function (response) {
                        if (response.data.result) {
                            self.relations.push(data)
                        } else {
                            alert(response.data.message)
                        }

                        self.addModeOff()
                        self.$refs.autocomplete.setValue('')
                    })
            },
            removeRelation (id) {
                let self = this

                return axios.post(this.removeapi, querystring.stringify({id: self.id, relation: id}), {headers: {'Content-Type': 'application/x-www-form-urlencoded'}})
                    .then(function (response) {
                        if (response.data.result) {
                            self.relations = self.relations.filter((item) => {
                                return item.id !== id
                            })
                        } else {
                            alert(response.data.message)
                        }
                    })
            },
            customerLink: function (id) {
                return this.customerLinkURL.replace('{id}', id)
            }
        },
        created () {
            if (this.relationapi !== undefined && this.relationapi !== null) {
                this.getData()
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// AttachCustomer.vue?2f0f0cbb